// Generar ID único
export const safeId = () =>
    typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : String(Date.now() + Math.random());

// Formatear moneda
export function moneyFmt(amount, currency) {
    const locale = currency === "PEN" ? "es-PE" : "en-US";
    const num = parseFloat(amount) || 0;
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        maximumFractionDigits: 2,
    }).format(num);
}

// Sanitizar nombre de archivo
export function sanitizeFilename(s) {
    return (s || "documento")
        .toString()
        .trim()
        .replace(/[\\/:*?"<>|]/g, "")
        .replace(/\s+/g, "_")
        .slice(0, 80);
}

// Convertir decimal a porcentaje para input
export function toPercentInput(decimal) {
    const n = Number(decimal);
    if (!Number.isFinite(n)) return "";
    return String(Math.round(n * 100 * 100) / 100);
}

// Convertir porcentaje a decimal
export function percentToDecimal(p) {
    const n = Number(p);
    if (!Number.isFinite(n)) return 0;
    return n / 100;
}

// Convertir imagen a DataURL
export async function fetchAsDataURL(url) {
    try {
        const res = await fetch(url);
        const blob = await res.blob();
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch {
        return null;
    }
}

// Convertir cualquier imagen (incluido SVG/WEBP) a PNG DataURL via canvas
// jsPDF no soporta SVG directamente, asi que rasterizamos
export async function imageToPngDataURL(url, targetSize = 200) {
    return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            try {
                const canvas = document.createElement('canvas');
                // Mantener proporcion, ajustar al targetSize
                const aspect = img.width / img.height;
                let w, h;
                if (aspect >= 1) {
                    w = targetSize;
                    h = targetSize / aspect;
                } else {
                    h = targetSize;
                    w = targetSize * aspect;
                }
                canvas.width = w;
                canvas.height = h;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, w, h);
                resolve(canvas.toDataURL('image/png'));
            } catch (err) {
                console.error('Error convirtiendo imagen a PNG:', err);
                resolve(null);
            }
        };
        img.onerror = () => {
            console.error('Error cargando imagen:', url);
            resolve(null);
        };
        img.src = url;
    });
}

// Formatear fecha
export function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-PE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
}

// Obtener fecha actual en formato YYYY-MM-DD (fecha local, no UTC)
export function getCurrentDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

// Obtener color de estado
export function getEstadoColor(estado) {
    const colores = {
        borrador: '#6b7280',
        enviada: '#3b82f6',
        aprobada: '#10b981',
        rechazada: '#ef4444'
    };
    return colores[estado] || '#6b7280';
}

